export default function RichText({ html, className = "", clamp = false }) {
  return (
    <div
      className={`
        text-[14px] leading-relaxed
        [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:text-[#1A237E] [&_h1]:mb-3
        [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-[#1A237E] [&_h2]:mb-2
        [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-[#1A237E] [&_h3]:mb-1
        [&_p]:mb-3 [&_p]:leading-7 [&_p]:text-gray-600
        [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-3
        [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-3
        [&_li]:mb-1
        [&_strong]:text-gray-800 [&_strong]:font-semibold
        [&_em]:italic
        [&_a]:text-pink-500 [&_a]:underline [&_a]:hover:text-pink-600
        [&_blockquote]:border-l-4 [&_blockquote]:border-pink-200
        [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:text-gray-500 [&_blockquote]:my-3
        [&_img]:rounded-xl [&_img]:shadow-sm [&_img]:my-3 [&_img]:max-w-full
        [&_table]:w-full [&_table]:border-collapse [&_table]:my-3
        [&_th]:border [&_th]:border-pink-100 [&_th]:bg-pink-50 [&_th]:p-2 [&_th]:text-left
        [&_td]:border [&_td]:border-pink-100 [&_td]:p-2
        [&_code]:bg-gray-100 [&_code]:px-1.5 [&_code]:rounded [&_code]:text-sm [&_code]:font-mono
        [&_pre]:bg-gray-100 [&_pre]:p-3 [&_pre]:rounded-xl [&_pre]:overflow-x-auto [&_pre]:my-3
        [&_hr]:border-pink-100 [&_hr]:my-4
        ${clamp ? "line-clamp-3" : ""}
        ${className}
      `}
      dangerouslySetInnerHTML={{ __html: html || "<p>—</p>" }}
    />
  );
}